
interface SidebarInterface {
  activityDefinitions: ActivityDefinition[];
  activityDefinitionTypes: EnumObject[];
  editor: boolean;
  localDefinition: ActivityDefinition;
  orchestrationRouteModels: OrchestrationRouteModel[];
  pipelinePhaseTypes: EnumObject[];
}

import ActivityDefinition from '@/models/activityDefinition';
import { ActivityDefinitionType, EnumObject, PipelinePhaseType, RouteType } from '@/models/enums';
import { OrchestrationRouteModel } from '@/models/orchestrationRouteModel';
import Vue, { PropType } from 'vue';
import { VueConstructor } from 'vue/types/vue';
import { mapActions, mapState } from 'vuex';
import { bus } from '@/main';
import { AxiosError, AxiosResponse } from 'axios';

const WorkflowsSidebarComponent = (Vue as VueConstructor<Vue & SidebarInterface>).extend({
  props: {
    localSelectedDefinition: {
      type: Object as PropType<ActivityDefinition>,
      required: true,
    },
    activityDefinitionTypes: {
      type: Array as PropType<EnumObject[]>,
      required: true,
    },
    pipelinePhaseTypes: {
      type: Array as PropType<EnumObject[]>,
      required: true,
    },
    editor: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    ...mapState<ActivityDefinition[]>('configStore', {
      orchestrationRouteModels: 'orchestrationRouteModels',
    }),
    ...mapState<ActivityDefinition[]>('activityDefinitionStore', {
      activityDefinitions: 'activityDefinitions',
    }),
    localDefinition(): ActivityDefinition | undefined {
      return this.activityDefinitions.find((x) => x.id === this.localSelectedDefinition.id);
    },
  },

  methods: {
    getActivityDefinitionType(type: number) {
      return ActivityDefinitionType[type];
    },

    getPipelinePhaseType(type: number) {
      return PipelinePhaseType[type];
    },
  },
});

export default WorkflowsSidebarComponent;
